import { getAssets, HydrationScript } from 'solid-js/web';

export function IndexHtml(P)
{
	const buildLink = P.build.storeForBuiltAssets == 'production' ? '_build' : '_devBuild';

	/* Needs to be separated from the JSX, otherwise the SSR interferes for some reason. */
	const basicData = `
		window.build = ${JSON.stringify(P.build)};
		window.site = ${JSON.stringify(P.site)};
		window.user = ${JSON.stringify(P.user.toJson())};
	`;

	return (
		<html lang='en'>
			<head>
				<meta charset='UTF-8' />
				<meta name='viewport' content='width=device-width, initial-scale=1.0' />
				<meta http-equiv='Content-type' content='text/html; charset=utf-8'/>

				{getAssets()}

				<HydrationScript />
			</head>
			<body>
				{P.children}

				<script>{basicData}</script>
				<script type='module' src={`/${buildLink}/${P.build.key}/BrowserApp.js`} />
			</body>
		</html>
	);
}

